export default "__VITE_ASSET__BddC6qQT__"